<template>
	<div>

		<section id="page-title" class="page-title-parallax page-title-dark" style="background: url('/static/images/teatro-colombo.png') center center no-repeat; background-size: cover; box-shadow:inset 0 0 0 2000px rgba(0,0,0,0.5); padding: 75px 0;" data-bottom-top="background-position:0px 300px;" data-top-bottom="background-position:0px -300px;">

			<div class="container clearfix">
				<h1>Quem Somos</h1>
				<!-- <span>Ficha de Companhia</span> -->
				<!-- <ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="#">Home</a></li>
					<li class="breadcrumb-item"><a href="#">Pages</a></li>
					<li class="breadcrumb-item active" aria-current="page">Jobs</li>
				</ol> -->
			</div>

		</section><!-- #page-title end -->

		<!-- Content
		============================================= -->
		<section id="content">

			<div class="content-wrap">

				<div class="container clearfix">

					<!-- <div class="col_three_fifth nobottommargin"> -->
					<div class="col-12">

						<p>
							<b>Idealização, coordenação, redação: </b> <a href="http://lattes.cnpq.br/6705831790844259" target="_blank">Prof. Dra. Virgínia de Almeida Bessa</a>
							<br><br>
							<b>Pesquisa de elencos:</b> Ana Carolina dos Santos Lebre, Anna Maria Greco Carvalho (bolsistas Pibic/CNPq), Vinicius Vali de Godoi (bolsista PUB-USP)
							<br><br>
							<b>Agradecimentos:</b> Prof. Dr. Walter Garcia da Silveira Junior (Instituto de Estudos Brasileiros da USP); Prof. Dr. José Geraldo Vinci de Moraes (FFLCH-USP); Prof. Dra. Maria Helena Serôdio (Centro de Estudos Teatrais da Universidade de Lisboa); Prof. Dr. Daniel Alves (Universidade Nova de Lisboa); Fundação de Amparo à Pesquisa do Estado de São Paulo (Processo FAPESP n° 2016/05184-0).
							<br><br>
							<b>Desenvolvedores: </b> A <a href="https://espressolabs.com.br/" target="_blank">Espresso Labs</a> é uma <i>software house</i> focada na análise de processos para oferecer soluções digitais assertivas com a melhor qualidade. Somos programadores, designers e engenheiros voltados para o desenvolvimento de aplicativos, sistemas, APIs e servidores sob medida.
						</p>

						<!-- <div class="fancy-title title-bottom-border">
							<h3>Como Pesquisar</h3>
						</div>

						<p>
							A
						</p> -->


					</div>

					<!-- <div class="col_two_fifth nobottommargin col_last">

						<div id="job-apply" class="heading-block highlight-me">
							<h2>Fotos</h2>
							<span>And we'll get back to you within 48 hours.</span>
						</div>

						<div>
							<img src="https://storage.googleapis.com/templates-html/companhia-arruda.png">
						</div>

					</div> -->

				</div>

			</div>

		</section>

	</div>
</template>



<script>

export default {
  name: 'AboutUs',
}

</script>


<style scoped>
.heading-block:after {
	margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue